module.exports = __webpack_public_path__ + "img/SAS_RedWhiteNomadShield.debd9bca.png";